import React from "react";

const IconPlayPink = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 258.43 288"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g transform="translate(18,0)">
      <path
        fill="#E95485"
        d="M 16.31 0.00 L 18.95 0.00 C 23.54 0.29 27.98 1.82 31.96 4.08 
       C 102.35 44.36 172.79 84.55 243.17 124.84 
       C 249.80 128.70 256.84 134.14 258.00 142.26 
       L 258.00 144.99 C 256.69 153.74 249.17 159.68 242.13 164.09 
       C 173.53 203.53 104.90 242.90 36.30 282.32 
       C 31.38 285.14 26.03 287.34 20.36 288.00 
       L 17.00 288.00 C 11.43 287.63 6.50 283.95 4.15 278.95 
       C -0.43 269.66 0.78 259.03 0.63 249.02 
       C 0.38 225.19 0.84 201.34 0.00 177.54 
       L 0.00 18.94 C 0.39 14.24 1.63 9.40 4.76 5.74 
       C 7.56 2.26 11.93 0.39 16.31 0.00 Z"
      />
    </g>
  </svg>
);
export default IconPlayPink;
